<template>
  <Section
    @back="$emit('back')"
    title="路線・駅設定"
    margin
    tip-message="路線・駅設定に戻る"
  >
    <template>
      <v-subheader>ターゲティング種別</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          <template v-for="targetType in targetTypes">
            {{ targetType }}
          </template>
        </v-flex>
      </v-layout>
    </template>
    <template>
      <v-subheader>対象路線</v-subheader>
      <v-layout v-for="(line, index) in targetLines" :key="index" pl-4>
        <v-flex xs3>{{ line.companyName }} > {{ line.lineName }}</v-flex>
        <v-flex xs1>
          <span v-if="line.countStation">{{ line.countStation }}駅</span>
        </v-flex>
        <v-flex xs1>
          <span v-if="line.radius">{{ line.radius }}m</span>
        </v-flex>
      </v-layout>
    </template>
    <CampaignModalPageConfirmTarget
      v-if="isTargetTypeStation"
      :menuSetting="menuSetting.target.railwayStationTargetObj"
    />
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import { RailwayTargetTypes } from '@/models/Menu/Constants'
import Section from './CampaignModalPageConfirmSection'
import CampaignModalPageConfirmTarget from './CampaignModalPageConfirmTarget'

export default {
  name: 'CampaignModalPageConfirmRailwayTarget',
  components: {
    Section,
    CampaignModalPageConfirmTarget,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    targetLines() {
      if (this.isTargetTypeStation) {
        return this.menuSetting.target.railwayStationTargetObj.railwayCompanies
          .map(company =>
            company.railwayLines.map(line => {
              return {
                companyName: company.name,
                lineName: line.name,
                countStation: line.stationIdAndNames.length,
                radius: line.radius,
              }
            }),
          )
          .flat()
      } else {
        return this.menuSetting.target.railwayLineTargetObj.railwayCompanies
          .map(company =>
            company.railwayLineIdAndNames.map(line => {
              return {
                companyName: company.railwayCompanyName,
                lineName: line.railwayLineName,
              }
            }),
          )
          .flat()
      }
    },
    targetTypes() {
      const targetTypes = []
      this.menuSetting.targetTypes.forEach(targetType => {
        switch (targetType) {
          case RailwayTargetTypes.Commuting:
            targetTypes.push('生活路線')
            break
          case RailwayTargetTypes.Passenger:
            targetTypes.push('乗客')
            break
          case RailwayTargetTypes.Station:
            targetTypes.push('駅')
            break
          default:
            break
        }
      })
      return targetTypes
    },
    isTargetTypeStation() {
      return this.menuSetting.targetTypes.includes(RailwayTargetTypes.Station)
    },
  },
  methods: {},
}
</script>
